(function () {
  'use strict';

  var nativeStillnessCartEnabled = false;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function parseJson(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function findVariant(product, color, pack) {
    return product.variants.find(function (variant) {
      return variant.option1 === color && variant.option2 === pack;
    });
  }

  function findVariantImageUrl(product, variant) {
    var image = variant && variant.featured_image
      ? variant.featured_image
      : product && product.featured_image;
    if (!image) return '';
    var imageUrl = typeof image === 'string' ? image : image.src || '';
    return imageUrl.indexOf('//') === 0 ? 'https:' + imageUrl : imageUrl;
  }

  function findTrayVariant(product, color) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      return variant.option1 === color && (!variant.option2 || variant.option2 === 'Single Tray');
    }) || null;
  }

  function findCandleVariant(product, color, pack) {
    if (!product || !product.variants) return null;
    var quantity = packQuantity(pack);
    return product.variants.find(function (variant) {
      return variant.option1 === color && packQuantity(variant.option2) === quantity;
    }) || null;
  }

  function findTrayImage(product, trayColor, taperColor, fallbackVariant) {
    var images = product && product.images ? product.images : [];
    var visualTaperColor = String(taperColor || '').toLowerCase() === 'amber'
      ? 'natural'
      : String(taperColor || '').toLowerCase();
    var match = 'tray-' + String(trayColor || '').toLowerCase() + '-' + visualTaperColor + '-candles';
    var image = images.find(function (candidate) {
      var source = candidate && candidate.src ? candidate.src : candidate;
      return String(source || '').toLowerCase().indexOf(match) > -1 &&
        String(source || '').toLowerCase().indexOf('closeup') > -1;
    }) || images.find(function (candidate) {
      var source = candidate && candidate.src ? candidate.src : candidate;
      return String(source || '').toLowerCase().indexOf(match) > -1;
    });
    var fallback = fallbackVariant && fallbackVariant.featured_image;
    return image && image.src
      ? image.src
      : image || (fallback && fallback.src ? fallback.src : fallback);
  }

  function packQuantity(pack) {
    var match = String(pack || '').match(/\d+/);
    return match ? Number(match[0]) : 1;
  }

  function closeOpusCart() {
    var opusHost = document.querySelector('#opus-shadow-container');
    var closeButton = opusHost && opusHost.shadowRoot
      ? opusHost.shadowRoot.querySelector('[aria-label="Close cart"], .opus-drawer-container-close')
      : null;

    if (closeButton && typeof closeButton.click === 'function') {
      closeButton.click();
    }
  }

  function handOffToStillnessCart() {
    if (!nativeStillnessCartEnabled) return;
    closeOpusCart();
    [100, 300, 700].forEach(function (delay) {
      window.setTimeout(closeOpusCart, delay);
    });
  }

  async function loadPreorder(productId) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 3000);

    async function read(path, allowMissing) {
      var response = await fetch('/apps/timesact/' + path, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      if (allowMissing && response.status === 404) return null;
      if (!response.ok) throw new Error('Timesact configuration unavailable');
      return response.json();
    }

    try {
      var config = await read('config?productId=' + encodeURIComponent(productId), true);
      if (config === null) return null;
      if (!config.product || !config.product.variants) throw new Error('Invalid Timesact product configuration');
      var shop = await read('shop');
      if (shop.isDisabled) return null;
      var settings = await read('shop/settings');
      if (!settings.settings) throw new Error('Invalid Timesact templates');
      return { variants: config.product.variants, shop: shop, templates: settings.settings };
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function getPreorder(preorder, variantId) {
    var variant = preorder && preorder.variants[variantId];
    var config = variant && variant.config;
    if (!config || variant.isPOEnabled === false) return null;
    if (config.status !== 'ACTIVE' && config.status !== 'NO_STOCK') return null;

    var defaultTemplate = preorder.shop.settings?.templates?.PO;
    var template = preorder.templates[config.settingsTemplate] || preorder.templates[defaultTemplate];
    var label = template?.cart?.labelText;
    var key = label?.isEnabled !== false && typeof label?.key === 'string' ? label.key.trim() : '';
    var value = typeof label?.value === 'string' ? label.value.trim() : '';

    var name = template?.button?.name;
    var unsupported = config.status === 'ACTIVE' && (
      !name || preorder.shop.hasSellingPlanEnabled || [name, key, key && value].some(function (text) {
        return text.includes('{{');
      })
    );

    return {
      soldOut: config.status === 'NO_STOCK' || unsupported,
      label: name,
      soldOutLabel: unsupported ? 'Pre-order unavailable' : (template?.button?.soldOutText || 'Sold out'),
      cartKey: key,
      cartValue: value
    };
  }

  function init(root) {
    if (root.hasAttribute('data-stillness-initialized')) return;
    root.setAttribute('data-stillness-initialized', 'true');

    var product = parseJson(root, '[data-stillness-product-json]');
    var trayProduct = parseJson(root, '[data-stillness-tray-json]');
    var candleProduct = parseJson(root, '[data-stillness-candle-json]');
    var candlestickVariant = parseJson(root, '[data-stillness-candlestick-json]');
    var productKind = root.getAttribute('data-stillness-product-kind') || 'standard-set';
    var subscriptionMarketEligible = root.getAttribute('data-subscription-market-eligible') === 'true';
    var saveTemplate = root.getAttribute('data-save-template') || 'Save __PERCENT__%';
    var addonDiscountCode = root.getAttribute('data-addon-discount-code') || '';
    var addonDiscountPercent = Number(root.getAttribute('data-addon-discount-percent')) || 0;
    var frequencyOneMonth = root.getAttribute('data-frequency-one-month') || '1 month';
    var frequencyMonths = root.getAttribute('data-frequency-months') || '__COUNT__ months';
    var subscriptionPriceTemplate = root.getAttribute('data-subscription-price-template') || '';
    var subscriptionUnavailable = root.getAttribute('data-subscription-unavailable') || 'Subscription unavailable for this selection.';
    if (!product || !product.variants || !product.variants.length) return;

    var initialVariant = product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];

    var state = {
      mode: 'set',
      color: root.getAttribute('data-initial-color') || initialVariant.option1,
      pack: root.getAttribute('data-initial-pack') || initialVariant.option2,
      addon: false,
      trayColor: root.getAttribute('data-initial-tray-color') || 'White',
      subscription: false,
      planId: null,
      planName: ''
    };

    var traySelectionInitialized = false;
    var preorder = null;
    var preorderStatus = 'loading';
    var addingToCart = false;
    var shippingLabel = root.querySelector('.candle-purchase-callout__icon--shipping')
      ?.parentElement.querySelector('.candle-purchase-callout__label');
    var originalShipping = shippingLabel?.innerHTML;
    var deliveryRow = root.closest('.m-main-product')
      ?.querySelector('.m-product-shipping--item:not(.m-product-shipping--text)');
    var originalDeliveryDisplay = deliveryRow?.style.getPropertyValue('display');
    var originalDeliveryPriority = deliveryRow?.style.getPropertyPriority('display');
    var showingPreorderShipping = false;

    var dom = {
      price: root.querySelector('[data-stillness-price]'),
      compare: root.querySelector('[data-stillness-compare]'),
      save: root.querySelector('[data-stillness-save]'),
      selectedColor: root.querySelector('[data-stillness-selected-color]'),
      selectedScent: root.querySelector('[data-stillness-selected-scent]'),
      selectedPack: root.querySelector('[data-stillness-selected-pack]'),
      selectedTray: root.querySelector('[data-stillness-selected-tray]'),
      trayColors: root.querySelector('[data-stillness-tray-colors]'),
      addonWrap: root.querySelector('[data-stillness-addon-wrap]'),
      addon: root.querySelector('[data-stillness-addon]'),
      addonGroup: root.querySelector('[data-stillness-addon-group]'),
      trayImage: root.querySelector('[data-stillness-tray-image]'),
      trayCompare: root.querySelector('[data-stillness-tray-compare]'),
      trayPrice: root.querySelector('[data-stillness-tray-price]'),
      trayStock: root.querySelector('[data-stillness-tray-stock]'),
      subscriptionGroup: root.querySelector('[data-stillness-subscription-group]'),
      subscriptionCard: root.querySelector('[data-stillness-subscription-card]'),
      subscription: root.querySelector('[data-stillness-subscription]'),
      frequencyOptions: root.querySelector('[data-stillness-frequency-options]'),
      subscriptionPrice: root.querySelector('[data-stillness-subscription-price]'),
      atcNote: root.querySelector('[data-stillness-atc-note]'),
      savings: root.querySelector('[data-stillness-savings]'),
      atc: root.querySelector('[data-stillness-atc]'),
      atcLabel: root.querySelector('[data-stillness-atc-label]'),
      atcPrices: root.querySelector('[data-stillness-atc-prices]'),
      atcCompare: root.querySelector('[data-stillness-atc-compare]'),
      atcPrice: root.querySelector('[data-stillness-atc-price]')
    };

    function setPressed(buttons, activeButton) {
      buttons.forEach(function (button) {
        var isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function calculate() {
      var variant = productKind === 'tray-set'
        ? product.variants.find(function (candidate) {
          return candidate.option1 === state.color && candidate.option2 === state.trayColor;
        })
        : findVariant(product, state.color, state.pack);
      var trayVariant = findTrayVariant(trayProduct, state.trayColor);
      var candleVariant = findCandleVariant(candleProduct, state.color, state.pack);
      var plans = candleVariant && candleVariant.plans ? candleVariant.plans : [];
      var selectedPlan = plans.find(function (plan) {
        return plan.id === state.planId;
      }) || plans.find(function (plan) {
        return plan.name === state.planName;
      }) || plans[0] || null;
      if (!variant) return null;

      var shouldAddTray = state.mode === 'kit' || state.addon;
      var subscriptionAvailable = Boolean(
        subscriptionMarketEligible &&
        packQuantity(state.pack) > 1 &&
        candleVariant &&
        candleVariant.available &&
        candlestickVariant &&
        candlestickVariant.available &&
        selectedPlan
      );
      var price = state.subscription && subscriptionAvailable
        ? candlestickVariant.price + selectedPlan.price
        : variant.price;
      var compare = state.subscription && subscriptionAvailable
        ? Math.max(candlestickVariant.compare_at_price || 0, candlestickVariant.price) +
          Math.max(candleVariant.compare_at_price || 0, candleVariant.price)
        : Math.max(variant.compare_at_price || 0, variant.price);

      if (shouldAddTray && trayVariant) {
        price += Math.round(trayVariant.price * (100 - addonDiscountPercent) / 100);
        compare += Math.max(trayVariant.compare_at_price || 0, trayVariant.price);
      }

      return {
        variant: variant,
        candleVariant: candleVariant,
        candlestickVariant: candlestickVariant,
        selectedPlan: selectedPlan,
        subscriptionAvailable: subscriptionAvailable,
        trayVariant: trayVariant,
        shouldAddTray: shouldAddTray,
        price: price,
        compare: compare,
        saved: Math.max(compare - price, 0)
      };
    }

    function renderFrequencyOptions(result) {
      if (!dom.frequencyOptions) return;
      var plans = result.candleVariant && result.candleVariant.plans ? result.candleVariant.plans : [];

      dom.frequencyOptions.innerHTML = '';
      plans.forEach(function (plan) {
        var match = plan.name.match(/every\s+(\d+)?\s*months?/i);
        var frequency = match && match[1] ? Number(match[1]) : 1;
        var button = document.createElement('button');
        button.className = 'stillness-configurator__frequency-button';
        button.type = 'button';
        button.setAttribute('data-stillness-frequency', String(plan.id));
        button.setAttribute('aria-pressed', plan.id === result.selectedPlan.id ? 'true' : 'false');
        button.classList.toggle('is-active', plan.id === result.selectedPlan.id);
        button.textContent = !match ? plan.name : frequency === 1
          ? frequencyOneMonth
          : frequencyMonths.replace('__COUNT__', String(frequency));
        button.addEventListener('click', function () {
          state.planId = plan.id;
          state.planName = plan.name;
          update();
        });
        dom.frequencyOptions.appendChild(button);
      });
    }

    async function refreshPreorder() {
      preorderStatus = 'loading';
      renderPurchase();
      try {
        try {
          preorder = await loadPreorder(product.id);
        } catch (_error) {
          preorder = await loadPreorder(product.id);
        }
        preorderStatus = 'ready';
      } catch (_error) {
        preorderStatus = 'failed';
      }
      renderPurchase();
    }

    function renderShipping(selectedPreorder) {
      if (selectedPreorder && !selectedPreorder.soldOut) {
        if (shippingLabel) {
          shippingLabel.textContent = selectedPreorder.cartKey && selectedPreorder.cartValue
            ? selectedPreorder.cartKey + ' ' + selectedPreorder.cartValue
            : selectedPreorder.label;
        }
        deliveryRow?.style.setProperty('display', 'none', 'important');
        showingPreorderShipping = true;
      } else if (showingPreorderShipping) {
        if (shippingLabel) shippingLabel.innerHTML = originalShipping;
        deliveryRow?.style.setProperty('display', originalDeliveryDisplay, originalDeliveryPriority);
        showingPreorderShipping = false;
      }
    }

    function renderPurchase(result) {
      result = result || calculate();
      if (!result) return;
      var selectedPreorder = state.subscription ? null : getPreorder(preorder, result.variant.id);
      renderShipping(selectedPreorder);
      if (addingToCart) return;

      var traySoldOut = result.shouldAddTray && (!result.trayVariant || !result.trayVariant.available);
      var soldOut = traySoldOut || (state.subscription
        ? !result.subscriptionAvailable
        : !result.variant.available || Boolean(selectedPreorder?.soldOut));
      var waitingForPreorder = !state.subscription && preorderStatus === 'loading';
      dom.atc.disabled = soldOut || waitingForPreorder;
      renderAtc(result, selectedPreorder, traySoldOut, soldOut);
    }

    function renderAtc(result, selectedPreorder, traySoldOut, soldOut) {
      if (traySoldOut) {
        dom.atcLabel.textContent = root.getAttribute('data-tray-out-of-stock') || 'Out of stock';
      } else if (soldOut) {
        dom.atcLabel.textContent = selectedPreorder?.soldOutLabel || 'Sold out';
      } else if (!state.subscription && preorderStatus !== 'ready') {
        dom.atcLabel.textContent = preorderStatus === 'loading' ? 'Checking availability…' : 'Retry availability check';
      } else {
        dom.atcLabel.textContent = selectedPreorder?.label || 'Add to cart';
      }
      dom.atcPrices.hidden = soldOut;
      dom.atcPrice.textContent = formatMoney(result.price);
      dom.atcCompare.hidden = soldOut || result.saved <= 0;
      dom.atcCompare.textContent = result.saved > 0 ? formatMoney(result.compare) : '';
    }

    function setAtcStatus(message) {
      dom.atcLabel.textContent = message;
      dom.atcPrices.hidden = true;
    }

    function updateTrayAvailability() {
      if (productKind === 'tray-set') return;
      var colors = ['White', 'Black'];
      var availableColors = colors.filter(function (color) {
        var variant = findTrayVariant(trayProduct, color);
        return variant && variant.available;
      });
      var outOfStock = root.getAttribute('data-tray-out-of-stock') || 'Out of stock';
      if (dom.addonGroup) dom.addonGroup.hidden = !availableColors.length;
      if (!availableColors.length) {
        state.mode = 'set';
        state.addon = false;
      }
      if (!traySelectionInitialized && availableColors.length && availableColors.indexOf(state.trayColor) === -1) {
        state.trayColor = availableColors[0];
      }
      traySelectionInitialized = true;
      root.querySelectorAll('[data-stillness-tray-color]').forEach(function (button) {
        var color = button.getAttribute('data-stillness-tray-color');
        var available = availableColors.indexOf(color) !== -1;
        var selected = color === state.trayColor;
        button.disabled = false;
        button.setAttribute('aria-label', color + (available ? '' : ': ' + outOfStock));
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-active', selected);
        button.classList.toggle('is-unavailable', !available);
      });
      if (dom.trayStock) {
        var selectedUnavailable = (state.mode === 'kit' || state.addon) && availableColors.indexOf(state.trayColor) === -1;
        dom.trayStock.hidden = !selectedUnavailable;
        dom.trayStock.textContent = selectedUnavailable
          ? state.trayColor + ': ' + outOfStock
          : '';
      }
    }

    function update() {
      updateTrayAvailability();
      var subscriptionPackEligible = packQuantity(state.pack) > 1;
      if (!subscriptionPackEligible) {
        state.subscription = false;
        if (dom.subscription) dom.subscription.checked = false;
      }
      if (dom.subscriptionGroup) {
        dom.subscriptionGroup.hidden = !subscriptionPackEligible;
      }

      var result = calculate();
      if (!result) return;
      if (state.subscription && !result.subscriptionAvailable) {
        state.subscription = false;
        if (dom.subscription) dom.subscription.checked = false;
        result = calculate();
      }
      if (dom.subscriptionGroup) dom.subscriptionGroup.hidden = !result.subscriptionAvailable;
      renderFrequencyOptions(result);

      var variantInput = root.querySelector('[data-stillness-variant-id]');
      if (variantInput && variantInput.value !== String(result.variant.id)) {
        variantInput.value = result.variant.id;
        variantInput.dataset.selectedVariant = result.variant.id;
        root.closest('.m-main-product').querySelectorAll('media-gallery, media-gallery-mobile').forEach(function (gallery) {
          if (gallery.slider && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(result.variant);
        });
      }

      var contents = root.closest('.m-main-product').querySelector('[data-stillness-contents-candles]');
      if (contents) contents.textContent = (packQuantity(state.pack) * 15) + ' Thin Candles';

      if (dom.price) dom.price.textContent = formatMoney(result.price);

      if (dom.compare) {
        dom.compare.hidden = result.saved <= 0;
        dom.compare.textContent = formatMoney(result.compare);
      }

      if (dom.save) {
        dom.save.hidden = result.saved <= 0;
        dom.save.textContent = result.saved > 0 ? 'Save ' + Math.round(result.saved * 100 / result.compare) + '%' : '';
      }

      if (dom.savings) {
        dom.savings.hidden = result.saved <= 0 || (
          productKind !== 'tray-set' &&
          state.pack === '1 Pack' &&
          !result.shouldAddTray
        );
        dom.savings.textContent = "You're saving " + formatMoney(result.saved) + ' on this order';
      }

      if (dom.trayColors) {
        dom.trayColors.hidden = !result.shouldAddTray;
      }

      if (dom.addon) {
        dom.addon.checked = result.shouldAddTray;
      }

      if (dom.trayCompare && result.trayVariant) {
        dom.trayCompare.textContent = formatMoney(result.trayVariant.price);
      }

      if (dom.trayPrice && result.trayVariant) {
        dom.trayPrice.textContent = formatMoney(
          Math.round(result.trayVariant.price * (100 - addonDiscountPercent) / 100)
        );
      }

      if (dom.trayImage && result.trayVariant) {
        var trayImageUrl = findTrayImage(trayProduct, state.trayColor, state.color, result.trayVariant);
        if (trayImageUrl) dom.trayImage.src = trayImageUrl;
      }

      dom.selectedColor.textContent = state.color;
      if (dom.selectedScent) {
        dom.selectedScent.textContent = result.candleVariant && result.candleVariant.scent
          ? result.candleVariant.scent
          : '';
      }
      if (dom.selectedPack) {
        var selectedPackButton = root.querySelector('[data-stillness-pack][aria-pressed="true"]');
        dom.selectedPack.textContent = selectedPackButton
          ? selectedPackButton.getAttribute('data-stillness-pack-summary')
          : state.pack;
      }
      dom.selectedTray.textContent = state.trayColor;

      root.querySelectorAll('[data-stillness-pack]').forEach(function (button) {
        var saving = button.querySelector('[data-stillness-pack-saving]');
        var buttonPack = button.getAttribute('data-stillness-pack');
        var buttonVariant = findCandleVariant(candleProduct, state.color, buttonPack);
        if (!saving) return;
        var reference = buttonVariant && Math.max(buttonVariant.compare_at_price || 0, buttonVariant.price);
        var price = buttonVariant && buttonVariant.price;
        if (state.subscription && buttonVariant && packQuantity(buttonPack) > 1) {
          var plan = buttonVariant.plans.find(function (candidate) {
            return candidate.name === result.selectedPlan.name;
          }) || buttonVariant.plans[0];
          if (plan) price = plan.price;
        }
        var percent = reference > price ? Math.round((reference - price) * 100 / reference) : 0;
        saving.hidden = percent <= 0;
        saving.textContent = percent > 0 ? saveTemplate.replace('__PERCENT__', String(percent)) : '';
      });
      renderPurchase(result);

      if (dom.subscriptionCard) {
        dom.subscriptionCard.classList.toggle('is-active', state.subscription);
      }

      if (dom.subscriptionPrice) {
        dom.subscriptionPrice.innerHTML = result.selectedPlan
          ? subscriptionPriceTemplate
            .replace('__COMPARE__', formatMoney(Math.max(result.candleVariant.compare_at_price || 0, result.candleVariant.price)))
            .replace('__FIRST__', formatMoney(result.selectedPlan.price))
            .replace('__RECURRING__', formatMoney(result.selectedPlan.recurringPrice))
            .replace('__CADENCE__', result.selectedPlan.name.toLowerCase().replace(/^deliver\s+/, ''))
            .replace('__COUNT__', String(packQuantity(state.pack) * 15))
          : subscriptionUnavailable;
        var refillCompare = dom.subscriptionPrice.querySelector('s');
        if (refillCompare && result.selectedPlan) {
          refillCompare.hidden = Math.max(result.candleVariant.compare_at_price || 0, result.candleVariant.price) <= result.selectedPlan.price;
        }
        if (result.selectedPlan && result.selectedPlan.initialOrderCount > 1 && result.selectedPlan.recurringPrice !== result.selectedPlan.price) {
          dom.subscriptionPrice.innerHTML = dom.subscriptionPrice.innerHTML.replace('first order', 'for the first ' + result.selectedPlan.initialOrderCount + ' deliveries');
        }
      }

      if (dom.atcNote) {
        dom.atcNote.hidden = !state.subscription;
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname + '?variant=' + result.variant.id);
      }
    }

    root.querySelectorAll('[data-stillness-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.mode = button.getAttribute('data-stillness-mode');
        state.addon = false;
        if (dom.addon) dom.addon.checked = state.mode === 'kit';
        setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-mode]')), button);
        update();
      });
    });

    root.querySelectorAll('[data-stillness-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.color = button.getAttribute('data-stillness-color');
        setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-color]')), button);
        update();
      });
    });

    root.querySelectorAll('[data-stillness-pack]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.pack = button.getAttribute('data-stillness-pack');
        setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-pack]')), button);
        update();
      });
    });

    root.querySelectorAll('[data-stillness-tray-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        state.trayColor = button.getAttribute('data-stillness-tray-color');
        setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-tray-color]')), button);
        update();
      });
    });

    root.querySelectorAll('[data-stillness-tray-variant-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.trayColor = button.getAttribute('data-stillness-tray-variant-color');
        setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-tray-variant-color]')), button);
        update();
      });
    });

    if (dom.addon) {
      dom.addon.addEventListener('change', function () {
        state.mode = dom.addon.checked ? 'kit' : 'set';
        state.addon = false;
        var modeButton = root.querySelector('[data-stillness-mode="' + state.mode + '"]');
        if (modeButton) {
          setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-stillness-mode]')), modeButton);
        }
        update();
      });
    }

    if (dom.subscription) {
      dom.subscription.addEventListener('change', function () {
        state.subscription = dom.subscription.checked;
        update();
      });
    }

    function applyAddonDiscount(result, response, sectionRequest) {
      if (!result.shouldAddTray || !addonDiscountCode) return Promise.resolve(response);

      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (cartResponse) {
          if (!cartResponse.ok) throw new Error('Cart request failed');
          return cartResponse.json();
        })
        .then(function (cartState) {
          var codes = (cartState.discount_codes || []).map(function (discount) {
            return discount.code;
          }).filter(Boolean);
          if (!codes.some(function (code) {
            return code.toLowerCase() === addonDiscountCode.toLowerCase();
          })) {
            codes.push(addonDiscountCode);
          }

          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(Object.assign({
              discount: codes.join(',')
            }, sectionRequest))
          });
        })
        .then(function (discountResponse) {
          if (!discountResponse.ok) throw new Error('Discount update failed');
          return discountResponse.json();
        })
        .catch(function () {
          return response;
        });
    }

    dom.atc.addEventListener('click', function () {
      var result = calculate();
      if (!result || dom.atc.disabled || addingToCart) return;
      if (!state.subscription && preorderStatus !== 'ready') {
        if (preorderStatus === 'failed') refreshPreorder();
        return;
      }
      var groupId = 'stillness-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var candleCount = packQuantity(state.pack) * 15;
      var candleLabel = candleCount + ' ' + state.color.toLowerCase() + ' taper candles';
      var candlestickLabel = '1 antique brass candlestick';
      var trayLabel = '1 ' + state.trayColor.toLowerCase() + ' candle tray';
      var stillnessSetImage = findVariantImageUrl(product, result.variant);

      if (state.subscription) {
        var items = [
          {
            id: result.candlestickVariant.id,
            quantity: 1,
            properties: {
              '_Stillness Set group': groupId,
              '_Stillness Set component': 'Candlestick',
              '_Stillness Set label 1': candlestickLabel,
              '_Stillness Set primary': 'true',
              '_Stillness Set image': stillnessSetImage
            }
          },
          {
            id: result.candleVariant.id,
            quantity: 1,
            selling_plan: result.selectedPlan.id,
            properties: {
              '_Stillness Set group': groupId,
              '_Stillness Set component': 'Candle refills',
              '_Stillness Set label 1': candleLabel,
              '_Stillness Set subscription': result.selectedPlan.name.replace(/^Deliver\s+/i, 'Candle refills ')
            }
          }
        ];
      } else {
        var secondLabel = productKind === 'tray-set' ? trayLabel : candlestickLabel;
        var items = [{
          id: result.variant.id,
          quantity: 1,
          properties: {
            '_Stillness Set group': groupId,
            '_Stillness Set component': 'Stillness Set',
            '_Stillness Set label 1': secondLabel,
            '_Stillness Set label 2': candleLabel,
            '_Stillness Set primary': 'true',
            '_Stillness Set image': stillnessSetImage
          }
        }];
        var selectedPreorder = getPreorder(preorder, result.variant.id);
        var key = selectedPreorder?.cartKey;
        if (key && selectedPreorder.cartValue && !key.startsWith('_')
          && !Object.prototype.hasOwnProperty.call(Object.prototype, key)) {
          items[0].properties[key] = selectedPreorder.cartValue;
        }
      }

      if (result.shouldAddTray && result.trayVariant) {
        items.push({
          id: result.trayVariant.id,
          quantity: 1,
          properties: {
            '_Stillness Set group': groupId,
            '_Stillness Set component': 'Tray',
            '_Stillness Set label 1': trayLabel
          }
        });
      }

      addingToCart = true;
      dom.atc.disabled = true;
      setAtcStatus('Adding...');

      var cart = nativeStillnessCartEnabled ? document.querySelector('m-cart-drawer') : null;
      var sectionRequest = {};
      if (cart && typeof cart.getSectionsToRender === 'function') {
        sectionRequest.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        sectionRequest.sections_url = window.location.pathname;
      }
      var requestBody = Object.assign({ items: items }, sectionRequest);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function (response) {
          return applyAddonDiscount(result, response, sectionRequest);
        })
        .then(function (response) {
          if (nativeStillnessCartEnabled && cart && typeof cart.renderContents === 'function' && response.sections) {
            cart.setAttribute('data-stillness-cart-active', 'true');
            cart.renderContents(response);
            handOffToStillnessCart();
            if (typeof cart.getCart === 'function') {
              cart.getCart().then(function (cartState) {
                cart.updateCartCount(cartState.item_count);
              });
            }
            document.dispatchEvent(new CustomEvent('stillness:cart-added', {
              detail: { product: response, groupId: groupId }
            }));
            return;
          }

          return fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' }
          })
            .then(function (cartResponse) {
              if (!cartResponse.ok) throw new Error('Cart request failed');
              return cartResponse.json();
            })
            .then(function (cartState) {
              var drawer = document.querySelector('m-cart-drawer');
              if (drawer && typeof drawer.updateCartCount === 'function') {
                drawer.updateCartCount(cartState.item_count);
              }
              if (typeof window.OpusSetCartData === 'function') {
                window.OpusSetCartData(cartState);
              } else if (typeof window.opusRefreshCart === 'function') {
                window.opusRefreshCart();
              }
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: cartState }
              }));
              document.dispatchEvent(new CustomEvent('stillness:cart-added', {
                detail: { product: response, groupId: groupId }
              }));
            });
        })
        .catch(function () {
          setAtcStatus('Error - try again');
          setTimeout(update, 1200);
        })
        .finally(function () {
          addingToCart = false;
          setTimeout(update, 300);
        });
    });

    update();
    refreshPreorder();
  }

  function initAll() {
    document.querySelectorAll('[data-stillness-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
